import { EXPORT_TYPE } from "../../component/button-in-phieu/constant";

export const LOAI_BENH_AN = {
	THONG_TIN_BENH_AN: {
		DEFAULT: 'THONG_TIN_BENH_AN',
		HO_SO_BENH_AN: 'HO_SO_BENH_AN',
		PHIEU_DIEU_TRI: 'PHIEU_DIEU_TRI',
		PHIEU_CHAM_SOC: 'PHIEU_CHAM_SOC',
		PHIEU_CHAM_SOC_KH: 'PCS_KE_HOACH',
		BIEN_BAN_HOI_CHAN: 'BIEN_BAN_HOI_CHAN',
		SO_KET_15_NGAY_DIEU_TRI: 'SO_KET_15_NGAY_DIEU_TRI',
		THEO_DOI_CHUC_NANG_SONG: 'THEO_DOI_CHUC_NANG_SONG',
		THEO_DOI_TRUYEN_DICH: 'THEO_DOI_TRUYEN_DICH',
		TIEN_SU_DI_UNG: 'TIEN_SU_DI_UNG',
		BIEN_BAN_HOI_CHAN_PHAU_THUAT: 'BIEN_BAN_HOI_CHAN_PHAU_THUAT',
		SO_HOI_CHAN: 'SO_HOI_CHAN',
		GIAY_BAO_TU: 'GIAY_BAO_TU',
		GIAY_NGHI_OM: 'GIAY_NGHI_OM',
		giayChungSinh: 'giayChungSinh',
	},
	QUA_TRINH_DIEU_TRI: 'QUA_TRINH_DIEU_TRI',
	PHIEU_KHAM_BENH: 'PHIEU_KHAM_BENH',
	PHIEU_XET_NGHIEM: 'PHIEU_XET_NGHIEM',
	PHIEU_CHAN_DOAN_HINH_ANH: 'PHIEU_CHAN_DOAN_HINH_ANH',
	PHIEU_CHUYEN_KHOA: 'PHIEU_CHUYEN_KHOA',
	DICH_VU_KHAC: 'DICH_VU_KHAC',
	DON_THUOC: 'DON_THUOC',
	VAT_TU: 'VAT_TU',
	MAU: 'MAU',
};

export const FORMIO_CODE = {
	BIEN_BAN_HOI_CHAN: 'noiTruTTBABienBanHoiChan',
	BIEN_BAN_HOI_CHAN_PHAU_THUAT: 'noiTruBienBanHoiChanPhauThuat',
	GIAY_BAO_TU: 'noiTruGiayBaoTu',
	GIAY_NGHI_OM: 'noiTruGiayNghiOm',
	PHIEU_CHAM_SOC: 'noiTruPhieuChamSoc',
	PHIEU_CHAM_SOC_KE_HOACH: 'noiTruPhieuChamSocKeHoach',
	SO_HOI_CHAN: 'noiTruSoHoiChan',
	SO_KET_15_NGAY_DIEU_TRI: 'noiTruSoKet15NgayDieuTri',
	THEO_DOI_CHUC_NANG_SONG: 'noiTruTheoDoiChucNangSong',
	THEO_DOI_TRUYEN_DICH_THEM_DICH_TRUYEN: 'noiTruTheoDoiTruyenDichThemMoiDichTruyen',
	THEO_DOI_TRUYEN_DICH_THONG_TIN_PHIEU: 'noiTruTheoDoiTruyenDichThongTinPhieu',
	TIEN_SU_DI_UNG: 'noiTruTienSuDiUng',
	PHIEU_DIEU_TRI: 'noiTruPhieuDieuTri',
	PHIEU_DIEU_TRI_DIALOG: 'noiTruThemPhieuDieuTri'
};

export type DocumentKeys = "PHIEU_DIEU_TRI" | "GIAY_BAO_TU" | "GIAY_NGHI_OM";
export const THONG_TIN_BENH_AN_CONFIG: Record<DocumentKeys, any> = {
	PHIEU_DIEU_TRI: {
		KEY: "PHIEU_DIEU_TRI",
		EXPORT_ID: "5d1aec65-73c6-245a-b412-7e01a2008893",
		EXPORT_CODE: "treatmentSheetId",
		TEMPLATE: {
			[EXPORT_TYPE.PDF]: "MAU_TO_DIEU_TRI_PDF",
			[EXPORT_TYPE.DOC]: "MAU_TO_DIEU_TRI_DOCX",
		}
	},
	GIAY_BAO_TU: {
		KEY: "GIAY_BAO_TU",
		EXPORT_ID: "d8a36e14-0f7d-57d8-6a2b-a96b87c66b4c",
		EXPORT_CODE: "deathCertificateId",
		TEMPLATE: {
			[EXPORT_TYPE.PDF]: "MAU_GIAY_BAO_TU_PDF",
			[EXPORT_TYPE.DOC]: "MAU_GIAY_BAO_TU_DOCX",
		}
	},
	GIAY_NGHI_OM: {
		KEY: "GIAY_NGHI_OM",
		EXPORT_ID: "d4286858-764c-27f0-2e11-e8051261cf3d",
		EXPORT_CODE: "sickCertificateId",
		TEMPLATE: {
			[EXPORT_TYPE.PDF]: "MAU_GIAY_NGHI_OM_PDF",
			[EXPORT_TYPE.DOC]: "MAU_GIAY_NGHI_OM_DOCX",
		}
	},
};

export const HO_SO_BENH_AN_FORM = {
  TRANG_1: 'medicalRecordPage1',
  TRANG_A: 'medicalRecordMain',
  TRANG_TONG_KET: 'medicalRecordConclusion',
  TRANG_BIA: 'medicalRecordCoverPage',
};

export const DAC_DIEM_LIEN_QUAN_BENH_FIELDS = [
  'medicalHistoryAlcohol',
  'medicalHistoryAlcoholMonth',
  'medicalHistoryAllergy',
  'medicalHistoryAllergyMonth',
  'medicalHistoryDrug',
  'medicalHistoryDrugMonth',
  'medicalHistoryOther',
  'medicalHistoryOtherMonth',
  'medicalHistoryStrongTobacco',
  'medicalHistoryStrongTobaccoMonth',
  'medicalHistoryTobacco',
  'medicalHistoryTobaccoMonth',
];

export const SINH_HIEU_FIELDS = ['pr', 'bt', 'bpSys', 'bpDia', 'rr', 'height', 'weight'];

export const CONFIG_CODES = {
  FIELDS: "fields",
  SCRIPT_FIELDS: "scriptFields",
  OBJ_FIELDS: "objFields",
}
